<template>
  <div class="frame-wrapper work-history-add">
    <div v-if="isMobileAny()" id="info" class="active">
      <span v-if="selectedSeasonId && selectedItemId"
        >ほ場を選択してください</span
      >
      <span v-else>作業項目を選択してください</span>
    </div>
    <div v-if="isMobileAny()" id="item-edit-area" @click="onStartEditMobile">
      <span class="active"></span>
    </div>
    <transition name="fade">
      <div class="top-frame-container" v-if="initialized && showTopFrame">
        <div class="top-frame">
          <div v-if="isMobileAny()" class="title-area">
            <h3>作業項目を選択</h3>
            <div class="btn-close" @click="hideTopFrame"></div>
          </div>
          <div v-else class="title-area">
            <h3 v-if="nowSelectingFlags">ほ場を選択</h3>
            <h3 v-else>作業項目を選択</h3>
          </div>
          <div v-if="nowSelectingFlags" class="item-summary">
            <div class="selection-frame">
              <input
                type="radio"
                :id="'sum-checkbox-' + selectedSeasonId"
                checked
              />
              <label
                :for="'sum-checkbox-' + selectedSeasonId"
                class="label col3"
                :style="getSeasonStyleObject(selectedSeasonId)"
                >{{ selectedSeason.season_name }}</label
              >
              <input
                type="radio"
                :id="'sum-checkboxB-' + selectedItemId"
                checked
              />
              <label
                :for="'sum-checkboxB-' + selectedItemId"
                class="label col2"
                :style="getItemStyleObject(selectedItemId)"
                >{{ selectedItem.item_name }}</label
              >
            </div>
            <div>
              <div
                id="selectItemButton"
                class="select-button"
                @click="onChangeItem"
              >
                作業項目を変更
              </div>
            </div>
          </div>
          <div v-if="nowSelectingFlags" class="message-area">
            <span
              >作業を実施した全てのほ場のピンをクリックして「入力する」に進んでください</span
            >
          </div>
          <div v-else>
            <div v-if="isMobileAny()" class="input-frame">
              <template v-for="season in seasons">
                <div :key="season.season_id">
                  <input
                    type="radio"
                    :id="'checkbox-' + season.season_id"
                    :key="season.season_id"
                    :value="season.season_id"
                    name="season"
                    v-model="selectedSeasonId"
                    @click="onSelectSeason"
                  />
                  <label
                    :for="'checkbox-' + season.season_id"
                    class="label col3"
                    :key="'lbl' + season.season_id"
                    >{{ season.season_name }}</label
                  >
                </div>
              </template>
            </div>
            <div v-else class="input-frame">
              <template v-for="season in seasons">
                <input
                  type="radio"
                  :id="'checkbox-' + season.season_id"
                  :key="season.season_id"
                  :value="season.season_id"
                  name="season"
                  v-model="selectedSeasonId"
                  @click="onSelectSeason"
                />
                <label
                  :for="'checkbox-' + season.season_id"
                  class="label col3"
                  :key="'lbl' + season.season_id"
                  :style="getSeasonStyleObject(season.season_id)"
                  >{{ season.season_name }}</label
                >
              </template>
            </div>

            <div v-if="selectedSeasonId && isMobileAny()" class="input-frame-B">
              <template v-for="item in selectedSeason.items">
                <div :key="item.item_id">
                  <input
                    type="radio"
                    :id="'checkboxB-' + item.item_id"
                    :key="item.item_id"
                    :value="item.item_id"
                    name="item"
                    v-model="selectedItemId"
                    @change="onSelectItem"
                  />
                  <label
                    :for="'checkboxB-' + item.item_id"
                    class="label col2"
                    :key="'lbl' + item.item_id"
                    >{{ item.item_name }}</label
                  >
                </div>
              </template>
            </div>
            <div
              v-if="selectedSeasonId && !isMobileAny()"
              class="input-frame-B"
            >
              <template v-for="item in selectedSeason.items">
                <input
                  type="radio"
                  :id="'checkboxB-' + item.item_id"
                  :key="item.item_id"
                  :value="item.item_id"
                  name="item"
                  v-model="selectedItemId"
                  @change="onSelectItem"
                />
                <label
                  :for="'checkboxB-' + item.item_id"
                  class="label col2"
                  :key="'lbl' + item.item_id"
                  :style="getItemStyleObject(item.item_id)"
                  >{{ item.item_name }}</label
                >
              </template>
            </div>
            <!-- <template v-if="selectedSeasonId && selectedItemId">
              <div
                v-if="selectedItem.is_not_paddy_field_item"
                id="selectFlagButton"
                class="select-button"
                @click="onSelectNotPaddyFieldItem"
              >
                作業内容を入力
              </div>
              <div
                v-else
                id="selectFlagButton"
                class="select-button"
                @click="onStartSelectingFlags"
              >
                田圃を選択
              </div>
            </template> -->
          </div>
        </div>
      </div>
    </transition>
    <transition v-if="selectedPaddyFields.length > 0" name="fade" appear>
      <div class="side-frame-container" v-if="!isMobileAny()">
        <div class="side-frame">
          <div id="side-frame-header">
            <div></div>
            <h4>選択済み</h4>
            <div class="btn-close" @click="clearSelectedPaddyFields"></div>
          </div>
          <div class="side-frame-content">
            <div class="side-frame-content-header">
              <div class="header-title2">{{ selectedItem.item_name }}</div>
              <table>
                <tr v-for="(item, index) in selectedBrands" :key="index">
                  <td v-if="index === 0" class="item-title">品種：</td>
                  <td v-else class="item-title"></td>
                  <td class="item-name">{{ item.brand_name }}</td>
                  <td class="item-count">{{ item.brand_count }}</td>
                  <td>枚</td>
                </tr>
                <tr>
                  <td class="item-title">面積計：</td>
                  <td class="item-name">{{ selectedAreaTotal }} (a)</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
            <div
              v-for="paddyField in selectedPaddyFields"
              :key="paddyField.paddy_field_id"
              class="side-frame-row"
            >
              <div>
                <span :class="getFlag(paddyField)"></span>
                <p>{{ paddyField.name }}</p>
              </div>
            </div>
          </div>

          <div id="side-frame-footer">
            <span
              class="btn-submit"
              :class="{ disable: selectedPaddyFields.length === 0 }"
              @click="onFixPaddyFields"
              >入力する</span
            >
          </div>
        </div>
      </div>
      <div v-else class="side-frame-container">
        <div id="select-box" class="active">
          {{ selectedPaddyFieldName }}
        </div>
        <div id="next-btn" class="active" @click="onFixPaddyFields">
          <span>入力する</span>
        </div>
      </div>
    </transition>
    <div
      v-if="selectionsFixed"
      class="center-frame-container"
    >
      <transition name="scale" @after-leave="selectionsFixed = false" appear>
        <div v-if="showCenterFrame" class="center-frame">
          <validation-observer ref="obs" v-slot="ObserverProps">
            <div class="title-area">
              <h3><span class="ricelog_pinicon_040"></span>作業項目入力</h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>

            <div id="edit-area">
              <span
                :class="{
                  active: anyItemDetailInput && !ObserverProps.invalid,
                }"
                @click="onSubmit"
                >保存する</span
              >
            </div>

            <section class="section">
              <div class="container">
                <dl class="columns">
                  <template v-for="itemDetail in selectedItem.item_details">
                    <dt :key="itemDetail.item_detail_id">
                      {{ itemDetail.item_detail_name }}
                    </dt>
                    <dd
                      v-if="itemDetail.item_detail_type === 'date'"
                      :key="'date-input-' + itemDetail.item_detail_id"
                    >
                      <template v-if="itemDetail.display_flg === true">
                        <ValidationProvider
                          class="input-with-unit"
                          rules="required"
                          immediate
                          v-slot="ProviderProps"
                        >
                          <input
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                            type="date"
                          />
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </template>
                      <template v-else>
                        <input
                          v-model="workItemHistories[itemDetail.item_detail_id]"
                          type="date"
                        />
                      </template>
                    </dd>
                    <dd
                      v-else-if="itemDetail.item_detail_type === 'textarea'"
                      :key="'textarea-' + itemDetail.item_detail_id"
                    >
                      <ValidationProvider
                        class="input-with-unit"
                        rules="max:1000"
                        v-slot="ProviderProps"
                      >
                        <textarea
                          v-model="workItemHistories[itemDetail.item_detail_id]"
                        ></textarea>
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dd
                      v-else-if="itemDetail.item_detail_type === 'list'"
                      :key="'input-' + itemDetail.item_detail_id"
                    >
                      <ValidationProvider
                        class="input-with-unit"
                        rules="required|max:100"
                        immediate
                        v-slot="ProviderProps"
                      >
                        <input
                          v-model="workItemHistories[itemDetail.item_detail_id]"
                          type="text"
                        />
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                      <div
                        v-if="
                          selectOptions[itemDetail.item_detail_key].length > 1
                        "
                        class="input-with-user"
                      >
                        <template
                          v-for="(user, index) in selectOptions[
                            itemDetail.item_detail_key
                          ]"
                        >
                          <label
                            class="label"
                            :key="'label-' + index"
                            @click="onAddUser(user, itemDetail.item_detail_id)"
                          >
                            {{ user.user_name }}</label
                          >
                        </template>
                      </div>
                    </dd>
                    <dd
                      v-else-if="itemDetail.item_detail_type === 'num'"
                      :key="'input-' + itemDetail.item_detail_id"
                      class="input-with-unit"
                    >
                      <ValidationProvider
                        class="input-with-unit"
                        rules="customDouble"
                        v-slot="ProviderProps"
                      >
                        <input
                          v-model="workItemHistories[itemDetail.item_detail_id]"
                          type="text"
                        />
                        <span v-if="itemDetail.item_detail_unit" class="unit">{{
                          itemDetail.item_detail_unit
                        }}</span>
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                    <dd
                      v-else
                      :key="'input-' + itemDetail.item_detail_id"
                      class="input-with-unit"
                    >
                      <ValidationProvider
                        class="input-with-unit"
                        rules="max:100"
                        v-slot="ProviderProps"
                      >
                        <input
                          v-model="workItemHistories[itemDetail.item_detail_id]"
                          type="text"
                        />
                        <span v-if="itemDetail.item_detail_unit" class="unit">{{
                          itemDetail.item_detail_unit
                        }}</span>
                        <div class="validation-error">
                          {{ ProviderProps.errors[0] }}
                        </div>
                      </ValidationProvider>
                    </dd>
                  </template>
                  <template>
                    <dt>
                      <div id="upload-area">
                        <label class="active">
                          <input
                            type="file"
                            ref="preview"
                            accept="image/*"
                            @change="readFile"
                            multiple
                          />画像アップロード
                        </label>
                      </div>
                    </dt>
                    <dd>
                      <div class="upload-area-view">
                        <template v-for="(row, index) in fileList">
                          <div :key="index">
                            <span class="active" @click="deletePreview(index)">
                            </span>
                            <img :src="row.data" />
                          </div>
                        </template>
                      </div>
                    </dd>
                  </template>
                </dl>
              </div>
            </section>
          </validation-observer>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoogleMaps from "@/mixins/googlemaps.js";
import Loader from "@/mixins/loader";
import isMobile from "@/mixins/ismobile";
import Compression from "@/mixins/compression";
import { Storage } from "aws-amplify";
import Dialog from "@/mixins/dialog";
import BigNumber from "bignumber.js";

const PATTERN_VALUE = { ADD: "1", UPDATE: "2" };

export default {
  mixins: [GoogleMaps, Loader, isMobile, Compression, Dialog],

  data() {
    return {
      initialized: false,
      userId: null,
      markers: [],
      seasons: [],
      // 作業履歴のサマリ(ほ場内)
      storedWorkHistorySummaries: null,
      // 作業履歴のサマリ(ほ場外)
      storedGlobalWorkHistorySummaries: null,
      // 作業項目選択画面を表示することを示すフラグ
      showTopFrame: false,
      // 選択した作業大分類のID
      selectedSeasonId: null,
      // 選択した作業項目のID
      selectedItemId: null,
      // 作業項目を決定して田圃を選択中であることを示すフラグ
      nowSelectingFlags: false,
      // 選択した田圃
      selectedPaddyFields: [],
      // 直近で選択状態にした田圃の名前
      selectedPaddyFieldName: null,
      // 田圃を決定したことを示すフラグ
      selectionsFixed: false,
      // 作業項目内容入力フォームを表示することを示すフラグ
      showCenterFrame: false,
      // 作業項目内容入力フォームにバインドするデータ
      workItemHistories: {}, // TODO workItemsに変更
      // 作業項目内容入力フォームに表示するdatalistの選択肢
      selectOptions: {},
      fileList: [],
      // 面積計
      selectedAreaTotal: 0,
      // 選択した田圃の品種情報
      selectedBrands: [],
    };
  },

  computed: {
    selectedSeason() {
      return this.seasons.find((e) => e.season_id === this.selectedSeasonId);
    },

    selectedItem() {
      return this.selectedSeason.items.find(
        (e) => e.item_id === this.selectedItemId
      );
    },

    anyItemDetailInput() {
      let b = false;
      for (const k in this.workItemHistories) {
        if (this.workItemHistories.hasOwnProperty(k)) {
          const element = this.workItemHistories[k];
          if (element) {
            b = true;
            break;
          }
        }
      }
      return b;
    },
  },

  async mounted() {
    this.loading(async () => {
      this.$emit("showMap");
      if (this.isMobileAny()) {
        this.$emit("hideMenu");
      }
      try {
        this.userId = await this.showUserId();
        var retSeasons = await this.retrieveSeasons();
        retSeasons.forEach((element) => {
          if (!element.color) {
            element.color = "#1a82b7";
          }
        });
        this.seasons = retSeasons;
        // マーカー初期表示
        await this.loadMarkers();
        // ユーザリスト取得
        await this.listUsers();
        // 初期化終了フラグ
        this.initialized = true;
        // モバイル表示の場合、初期表示時は作業項目選択エリアは表示しない
        if (this.isMobileAny()) {
          this.showTopFrame = false;
        } else {
          this.showTopFrame = true;
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  },

  destroyed() {
    this.clearMarkers();
  },

  methods: {
    ...mapActions([
      "retrieveSeasons",
      "retrievePaddyFields",
      "retrievePaddyFieldHistories",
      "retrieveGlobalWorkHistories",
      "insertWorkHistories",
      "insertGlobalWorkHistory",
      "showUsers",
      "showUserId",
    ]),
    ...mapGetters(["getPaddyFields", "getDisplayName", "getManagements"]),

    async loadMarkers() {
      // 最新の田圃の位置情報を取得
      await this.retrievePaddyFields();
      if (this.getPaddyFields().length === 0) {
        return;
      }

      // 作業履歴のサマリを取得
      this.storedWorkHistorySummaries =
        await this.retrievePaddyFieldHistories();
      this.storedGlobalWorkHistorySummaries =
        await this.retrieveGlobalWorkHistories({});
      // 現在マップに残っているマーカーをクリア
      this.clearMarkers();
      // マーカー表示
      this.putMarkers();
    },

    putMarkers() {
      const { Marker } = this.google.maps;
      let paddyFields = this.getPaddyFields();
      paddyFields.forEach((paddyField) => {
        const lat = parseFloat(paddyField.map_pos.split(",")[0]);
        const lng = parseFloat(paddyField.map_pos.split(",")[1]);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
        });
        marker.set("paddyField", paddyField);
        marker.setIcon(this.buildMarkerIconProps(marker, false, true));
        this.setInfoWindow(marker, paddyField);
        this.markers.push(marker);
      });
    },

    setInfoWindow(marker, paddyField) {
      var message = [];
      if (paddyField.name) {
        message.push(paddyField.name);
      }
      if (paddyField.area) {
        message.push(paddyField.area + "&nbsp(a)");
      }
      // 品種はマスタの値を表示
      if (paddyField.brand) {
        message.push(paddyField.brand);
      }
      // 耕作者
      if (paddyField.kousakusha) {
        message.push(paddyField.kousakusha);
      }

      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function () {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function () {
        infowin.close();
      });
    },

    onSelectSeason() {
      this.selectedItemId = null;
    },

    onSelectItem() {
      // 選択した作業項目の登録状況でマーカーの色を変える
      this.markers.forEach((marker) => {
        marker.setIcon(this.buildMarkerIconProps(marker));
      });

      // 作業項目選択した場合、各作業に応じて画面切り替え
      if (this.selectedSeasonId && this.selectedItemId) {
        if (this.selectedItem.is_not_paddy_field_item) {
          // 田圃外作業内容入力開始
          this.onSelectNotPaddyFieldItem();
        } else {
          // 田圃選択開始
          this.onStartSelectingFlags();
        }
      }
    },

    onStartSelectingFlags() {
      // 田んぼが1つ以上選択された際にリストを表示するため、フラグは別の場所で更新
      if (this.isMobileAny()) {
        this.showTopFrame = false;
        // 作業項目変更時のイベント処理を実行後に、マーカーのイベントリスナーを追加する
        this.onChangeItem();
      } else {
        this.nowSelectingFlags = true;
      }
      this.setSelectListener();
    },

    onChangeItem() {
      this.nowSelectingFlags = false;
      this.markers.forEach((e) => {
        this.google.maps.event.clearInstanceListeners(e);
      });
    },

    onSelectNotPaddyFieldItem() {
      let _showMess = false;
      // 上書きの場合、メッセージ表示
      if (this.selectedItem.item_pattern === PATTERN_VALUE.UPDATE) {
        // ほ場外作業
        if (
          this.storedGlobalWorkHistorySummaries &&
          this.storedGlobalWorkHistorySummaries.data
        ) {
          const workGlobalHistory = 
            this.storedGlobalWorkHistorySummaries.data.find(
            (e) => e.item_id === this.selectedItemId
            );
          if (workGlobalHistory) {
            _showMess = true;
          }
        }
      }
      if (_showMess) {
        this.showConfirm(
          "すでに実績が登録されていますが、入力を継続しますか",
          this.displayTopFrame
        );
      } else {
        this.displayTopFrame();
      }
    },

    onFixPaddyFields() {
      if (this.selectedPaddyFields.length === 0) {
        return;
      }
      let _showMess = false;
      for (const item of this.selectedPaddyFields) {
        if (this.isSelectedItemStored(item)) {
          _showMess = true;
          // 追加の場合、メッセージは表示しない
          if (this.selectedItem.item_pattern === PATTERN_VALUE.ADD) {
            _showMess = false;
          }
          break;
        }
      }
      if (_showMess) {
        this.showConfirm(
          "すでに実績が登録されているほ場が選択されていますが、入力を継続しますか",
          this.displayTopFrame
        );
      } else {
        this.displayTopFrame();
      }
    },

    displayTopFrame() {
      // フォームは作業項目マスタ次第で動的に変わる。
      // フォームの入力値をバインドするオブジェクトworkItemHistoriesは普通に利用したのでは
      // リアクティブにならない事があるので、$set()を使って毎回オブジェクト内のプロパティを初期化する。
      this.workItemHistories = {};

      const tmpLastInputValue = this.getItemLastInputValue();

      this.selectedItem.item_details.forEach((element) => {
        this.$set(this.workItemHistories, element.item_detail_id, "");

        // 作業者の初期値をログインユーザに、実施日の初期値を当日に設定
        if (
          element.item_detail_type === "list" &&
          element.item_detail_key === "users"
        ) {
          this.workItemHistories[element.item_detail_id] =
            this.getDisplayName();
        } else if (
          element.item_detail_type === "date" &&
          element.display_flg === true
        ) {
          var today = new Date();
          today.setDate(today.getDate());
          var yyyy = today.getFullYear();
          var mm = ("0" + (today.getMonth() + 1)).slice(-2);
          var dd = ("0" + today.getDate()).slice(-2);
          this.workItemHistories[element.item_detail_id] =
            yyyy + "-" + mm + "-" + dd;
        } else {
          // 前回入力値設定
          if (tmpLastInputValue !== null && tmpLastInputValue.work_items) {
            const lastVal =
              tmpLastInputValue.work_items[element.item_detail_id];
            if (lastVal !== null) {
              this.workItemHistories[element.item_detail_id] = lastVal;
            }
          }
        }
      });

      this.fileList = [];

      this.selectionsFixed = true;
      this.showCenterFrame = true;
    },

    hideCenterFrame() {
      this.showCenterFrame = false;
      this.workItemHistories = {};
    },
    hideTopFrame() {
      this.showTopFrame = false;
    },

    async onSubmit() {
      this.loading(async () => {
        try {
          // 画像の登録
          const nowDatetime = this.formatDatetime(new Date());
          let s3FileNames = [];

          const mngDatas = this.getManagements();
          const mngId = mngDatas[0]["management_id"];

          for (let i = 0; i < this.fileList.length; i++) {
            const ext = this.fileList[i].fileName.substr(
              this.fileList[i].fileName.lastIndexOf(".")
            );
            const s3FileName =
              mngId + "/image/" + nowDatetime + "/" + (i + 1) + ext;
            s3FileNames.push(s3FileName);
            await Storage.put(s3FileName, this.fileList[i].file, {
              level: "public",
              contentType: this.fileList[i].type,
            });
          }

          // 値がブランクの項目は削除
          for (const k in this.workItemHistories) {
            if (this.workItemHistories.hasOwnProperty(k)) {
              const val = this.workItemHistories[k];
              if (!val) {
                delete this.workItemHistories[k];
              }
            }
          }

          if (this.selectedItem.is_not_paddy_field_item) {
            const globalHistories = await this.retrieveGlobalWorkHistories({id: this.selectedItemId});
            let _workHistId = null;
            // 追加登録か上書きか判定
            if (this.selectedItem.item_pattern === PATTERN_VALUE.UPDATE) {
              if (globalHistories && globalHistories.data && globalHistories.data.length > 0) {
                _workHistId = globalHistories.data[0].work_history_id;
              }
            }
            // 田圃外作業の登録
            await this.insertGlobalWorkHistory({
              season: this.selectedSeason,
              item: this.selectedItem,
              workItems: this.workItemHistories,
              imagePaths: s3FileNames,
              workHistoryId: _workHistId,
            });
          } else {
            // 選択した作業項目の作業履歴がある田圃については作業履歴IDもAPIにわたす
            const pfHistories = await this.retrievePaddyFieldHistories();
            let workHistoryIdMap = {}; // 田圃履歴IDと作業履歴IDのマップ
            if (pfHistories && pfHistories.data) {
              const pfIds = this.selectedPaddyFields.map(
                (e) => e.paddy_field_id
              );
              pfHistories.data
                .filter(
                  (e) =>
                    e.item_id === this.selectedItemId &&
                    pfIds.includes(e.paddy_field_id)
                )
                .forEach((e) => {
                  workHistoryIdMap[e.paddy_field_id] = e.work_history_id;
                });
            }

            // 追加登録か上書きか判定
            if (this.selectedItem.item_pattern === PATTERN_VALUE.ADD) {
              // 追加の場合、キー情報を削除する
              workHistoryIdMap = {};
            }
            // 田圃作業の登録
            await this.insertWorkHistories({
              paddyFields: this.selectedPaddyFields,
              season: this.selectedSeason,
              item: this.selectedItem,
              workItems: this.workItemHistories,
              workHistoryIdMap: workHistoryIdMap,
              imagePaths: s3FileNames,
              areaTotal: this.selectedAreaTotal,
            });
          }
          // 内部データクリア
          // this.selectedSeasonId = null;
          // this.selectedItemId = null;
          // this.nowSelectingFlags = false;
          this.selectedPaddyFields = [];
          this.selectionsFixed = false;
          this.showCenterFrame = false;
          this.workItemHistories = {};
          // マーカーをリロード
          await this.loadMarkers();

          // 田圃作業の場合は、作業は選択状態のままかつアイコンも完了状態のままにするために、選択時の処理を実行する
          if (!this.selectedItem.is_not_paddy_field_item) {
            this.onSelectItem();
          }
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },

    setSelectListener() {
      this.markers.forEach((marker) => {
        marker.addListener("click", () => {
          // マーカーの選択状況を反転
          marker.setIcon(this.buildMarkerIconProps(marker, true));

          // 選択済みのマーカーか
          let selected = this.selectedPaddyFields.find((e) => {
            return e === marker.get("paddyField");
          });
          if (selected) {
            // 選択リストから削除
            this.selectedPaddyFields = this.selectedPaddyFields.filter(
              (e) => e !== marker.get("paddyField")
            );
            // 選択時の田圃名をクリアする
            this.selectedPaddyFieldName = null;
          } else {
            // 選択リストに追加
            this.selectedPaddyFields.push(marker.get("paddyField"));
            // 選択時の田圃名を設定する
            this.selectedPaddyFieldName = marker.get("paddyField").name;
          }
          // 面積計再計算、品種情報再設定
          let areaTotal = new BigNumber(0);
          let tmpBrands = {};
          let tmpBrandNotSet = {
            brand_name: "-",
            brand_count: 0,
          };
          for (const item of this.selectedPaddyFields) {
            // 面積
            if (item.area) {
              areaTotal = areaTotal.plus(item.area);
            }
            // 品種
            if (item.brand_id) {
              const tmpBrand = tmpBrands[item.brand_id];
              if (tmpBrand) {
                tmpBrand.brand_count++;
              } else {
                // 品種マスタに登録されている場合
                if (item.brand) {
                  tmpBrands[item.brand_id] = {
                    brand_name: item.brand,
                    brand_count: 1,
                    brand_id: item.brand_id,
                  };
                } else {
                  // マスタに品種が存在しなかったら、未設定と同様にカウント
                  tmpBrandNotSet.brand_count++;
                }
              }
            } else {
              tmpBrandNotSet.brand_count++;
            }
          }
          this.selectedAreaTotal = areaTotal.toNumber();
          this.selectedBrands = Object.values(tmpBrands);
          if (tmpBrandNotSet.brand_count > 0) {
            this.selectedBrands.push(tmpBrandNotSet);
          }
        });
      });
    },

    buildMarkerIconProps(marker, toggleSelection = false, init = false) {
      // 選択した作業項目をすでに登録済みのマーカーか
      let stored = this.isSelectedItemStored(marker.get("paddyField"));
      // 選択済みのマーカーか
      let selected = this.selectedPaddyFields.find((e) => {
        return e === marker.get("paddyField");
      });
      if (toggleSelection) {
        // 選択を反転
        selected = !selected;
      }
      // アイコンファイル名の組み立て
      let flagType = marker.get("paddyField").pin_type
        ? marker.get("paddyField").pin_type
        : "ricelog_pinicon_040";
      let iconName = "";
      if (init) {
        iconName += flagType;
      } else {
        if (stored) {
          iconName += flagType.slice(0, -1) + "1";
        } else {
          iconName += flagType;
        }
        if (selected) {
          var type = parseInt(iconName.slice(-1), 10) + 2;
          iconName = iconName.slice(0, -1) + type;
        }
      }

      let iconProps = { url: require("@/assets/pin/" + iconName + ".png") };
      if (selected) {
        iconProps = Object.assign(iconProps, {
          scaledSize: { width: 24, height: 42 },
          anchor: { x: 12, y: 42 },
        });
      } else {
        iconProps = Object.assign(iconProps, {
          scaledSize: { width: 24, height: 42 },
          anchor: { x: 12, y: 42 },
        });
      }
      return iconProps;
    },

    isSelectedItemStored(paddyField) {
      let stored = false;
      if (this.selectedItemId) {
        // 作業項目は選択済み
        if (
          this.storedWorkHistorySummaries &&
          this.storedWorkHistorySummaries.data
        ) {
          // 全田圃の作業履歴は取得済み
          const workHistory = this.storedWorkHistorySummaries.data.find(
            (e) =>
              e.paddy_field_id === paddyField.paddy_field_id &&
              e.item_id === this.selectedItemId
          );
          if (workHistory) {
            stored = true;
          }
        }
      }
      return stored;
    },

    getItemLastInputValue() {
      if (this.selectedItemId) {
        if (this.selectedItem.is_not_paddy_field_item) {
          // ほ場外作業
          if (
            this.storedGlobalWorkHistorySummaries &&
            this.storedGlobalWorkHistorySummaries.data
          ) {
            const tmpGlobalWorkHistories =
              this.storedGlobalWorkHistorySummaries.data.filter(
                (e) => e.item_id === this.selectedItemId
              );
            if (tmpGlobalWorkHistories.length > 0) {
              tmpGlobalWorkHistories.sort(function (a, b) {
                return a.create_datetime < b.create_datetime ? 1 : -1;
              });
              const lastData = tmpGlobalWorkHistories.find(m => m.create_user_id === this.userId && m.update_user_id === this.userId);
              if (lastData) {
                return lastData;
              }
              return tmpGlobalWorkHistories[0];
            }
          }
        } else {
          // ほ場内作業
          if (
            this.storedWorkHistorySummaries &&
            this.storedWorkHistorySummaries.data
          ) {
            const tmpWorkHistories =
              this.storedWorkHistorySummaries.data.filter(
                (e) => e.item_id === this.selectedItemId
              );
            if (tmpWorkHistories.length > 0) {
              tmpWorkHistories.sort(function (a, b) {
                return a.create_datetime < b.create_datetime ? 1 : -1;
              });
              const lastData = tmpWorkHistories.find(m => m.create_user_id === this.userId && m.update_user_id === this.userId);
              if (lastData) {
                return lastData;
              }
              return tmpWorkHistories[0];
            }
          }
        }
      }
      return null;
    },

    getFlag(paddyField) {
      if (this.isSelectedItemStored(paddyField)) {
        if (paddyField.pin_type) {
          return paddyField.pin_type.slice(0, -1) + "1";
        } else {
          return "ricelog_pinicon_041";
        }
      } else {
        if (paddyField.pin_type) {
          return paddyField.pin_type;
        } else {
          return "ricelog_pinicon_040";
        }
      }
    },

    clearMarkers() {
      this.markers.forEach((e) => {
        // Mapとの紐付けを解除しイベントリスナーを削除
        e.setMap(null);
        this.google.maps.event.clearInstanceListeners(e);
      });
      this.markers = [];
    },

    async listUsers() {
      let userList = [];
      this.selectOptions = [];
      try {
        const Users = await this.showUsers();

        // ユーザデータの整形
        Users.forEach((user) => {
          let _tmp = {};
          user.Attributes.forEach((attr) => {
            if (attr.Name === "custom:display_name") {
              _tmp.user_name = attr.Value;
            } else if (attr.Name === "custom:user_id") {
              _tmp.user_id = attr.Value;
            }
          });
          userList.push(_tmp);
        });
      } catch (e) {
        console.error(e);
      }

      this.selectOptions["users"] = userList;
    },

    onStartEditMobile() {
      this.showTopFrame = true;
    },

    clearSelectedPaddyFields() {
      this.selectedPaddyFields.forEach((item) => {
        // markerオブジェクト取得
        const nowSelected = this.markers.find(
          (m) => m.get("paddyField") === item
        );

        // マーカーの選択状況を反転
        nowSelected.setIcon(this.buildMarkerIconProps(nowSelected, true));
      });
      // 選択済みリストクリア
      this.selectedPaddyFields = [];
    },

    async readFile() {
      this.loading(async () => {
        const files = this.$refs.preview.files;
        for (const file of files) {
          try {
            const compFile = await Compression.getCompressImageFileAsync(file);
            const picture = await this.getBase64(compFile);
            this.fileList.push({
              fileName: file.name,
              size: compFile.size,
              type: file.type,
              data: picture,
              file: compFile,
            });
          } catch (error) {
            console.log(error);
          }
        }
        this.$refs.preview.value = "";
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    deletePreview(index) {
      this.fileList.splice(index, 1);
    },
    formatDatetime(src, format = "YYYYMMDDHHmmssSSS") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      dest = dest.replace(/SSS/, ("0" + date.getMilliseconds()).slice(-3));
      return dest;
    },
    onAddUser(user, detailId) {
      let _name = "";
      if (
        this.workItemHistories[detailId] &&
        this.workItemHistories[detailId].length > 0
      ) {
        _name = this.workItemHistories[detailId] + "、";
      }
      _name = _name + user.user_name;
      this.workItemHistories[detailId] = _name;
    },

    getSeasonStyleObject(id) {
      const season = this.seasons.find((m) => m.season_id === id);
      if (id === this.selectedSeasonId) {
        return {
          background: season.color,
        };
      } else {
        return {
          color: season.color,
        };
      }
    },
    getItemStyleObject(id) {
      if (id === this.selectedItemId) {
        return {
          background: this.selectedSeason.color,
        };
      } else {
        return {
          color: this.selectedSeason.color,
        };
      }
    },
  },
};
</script>

<style lang="scss">
// @import "../constants/constants.scss";

$side-frame-width: 350px;

.work-history-add {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .mobile & {
      height: 0;

      #info {
        position: fixed;
        align-items: center;
        background: rgba(83, 54, 155, 0.8);
        margin: 48px 0 0 0;
        width: 100%;
        height: 33px;
        text-align: center;
        color: #fff;
        font-size: 0.7rem;
        display: none;
        opacity: 0;
        transition: opacity 0.3s;
      }
      #info.active {
        display: grid;
        z-index: 21;
        opacity: 1;
      }

      #select-box {
        width: 90%;
        height: 30px;
        color: #333;
        font-size: 0.8rem;
        text-align: center;
        position: fixed;
        bottom: 65px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        display: none;
        align-items: center;
        border-radius: 15px;
        box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);
        z-index: 20;
      }
      #select-box.active {
        display: grid;
      }
      #next-btn {
        width: 100%;
        height: 50px;
        text-align: center;
        background: rgba(83, 54, 155, 0.8);
        position: fixed;
        bottom: 0;
        left: 0;
        display: none;
        align-items: center;
        cursor: pointer;
        z-index: 20;
      }
      #next-btn.active {
        display: grid;
      }
      #next-btn span {
        color: #fff;
        font-size: 1rem;
      }
      #next-btn span::before {
        white-space: pre;
        content: "    ";
        display: inline-block;
        background: url("~@/assets/icons/ic_next.svg") no-repeat left -2px;
        width: 26px;
        height: 20px;
        background-size: contain;
        vertical-align: middle;
      }

      #item-edit-area {
        // display: flex;
        // justify-content: flex-start;
        width: 60px;
        // position: fixed;
        text-align: center;
        background: rgba(256, 256, 256);
        margin: 90px 10px 10px auto;
        height: 60px;
        border-radius: 40px;
      }
      #item-edit-area span {
        display: block;
        font-size: 28px;
        // padding: 3px 0px;
        // margin: 10px 0;
        // text-align: center;
        color: var(--purple);
        // margin: 8px 15px;
        padding: 10px;
      }

      #item-edit-area span.active {
        // border-bottom: solid 4px var(--purple);
        cursor: pointer;
      }

      #item-edit-area span::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
        // background-size: 20px 20px;
        // padding: 0 0 0 15px;
      }
    }
  }
  .top-frame-container {
    width: 100%;
    max-width: 520px;
    //   padding: 30px;
    position: absolute;
    top: 30px;
    left: 30px;
    transition: height 0.5s;

    .mobile & {
      top: 0px;
      left: 0px;
    }

    .top-frame {
      // width: 100%;
      // max-width: 480px;
      // min-width: 350px;
      min-height: 100px;
      padding: 20px;
      // margin-right: $side-frame-width;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      transition: height 0.5s;

      .mobile & {
        height: 100vh;
        width: 100%;
        position: absolute;
        top: 0;
        border-radius: unset;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.8);
        z-index: 100;
        display: block;
        padding: unset;
      }
    }

    .top-frame .title-area {
      border-bottom: none;
      display: grid;
      grid-template-columns: 1fr 200px;
      align-items: center;
      margin: 0;
      padding: 0;

      .mobile & {
        font-size: 0.9em;
        width: 100%;
        height: 60px;
        padding: 15px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 32px;
        align-items: center;
        border-bottom: solid 1px #ddd;

        h3 {
          margin: 0;
          padding: 0 0 0 40px;
          display: flex;
          align-items: center;
        }

        h3 span {
          width: 25px;
          height: 45px;
          display: inline-block;
          margin: 0 10px 0 0;
        }

        .btn-close {
          cursor: pointer;
          width: 32px;
          height: 32px;
          background: url("~@/assets/icons/ic_cancel.svg") no-repeat center
            center;
          background-size: contain;
        }
      }

      h3 {
        background: url("~@/assets/icons/ic_style_black.svg") no-repeat left
          center;
        background-size: 30px 30px;
      }
    }
    .top-frame h3 {
      padding: 0 0 0 2em;
      margin: 0px 15px 15px 15px;
      .mobile & {
        margin: 0px 15px 0px 15px;
      }
    }
    .top-frame .selectCal {
      text-align: right;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }

    .top-frame .selectCal:active {
      opacity: 0.5;
      /* transition: 0.5s; */
    }

    .arrow-left {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      margin: 0 10px 0 0;
      cursor: pointer;
    }

    .arrow-left:active {
      transform: scale(1.2);
    }

    .arrow-right {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      transform: rotate(180deg);
      margin: 0 0 0 10px;
      cursor: pointer;
    }

    .arrow-right:active {
      transform: scale(1.2);
    }

    .top-frame .filter {
      text-align: right;
      display: block;
      cursor: pointer;
      font-size: 14px;
      margin: 0 20px 0 0;
      padding: 0;
      text-decoration: none;
      color: var(--purple);
    }

    .top-frame .filter::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_sort.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 20px;
    }

    .top-frame .filter:active {
      opacity: 0.5;
    }

    input[type="radio"] {
      display: none;
    }

    .input-frame-wrap {
      height: 100px;
      display: block;
      overflow: hidden;
      transition: ease-in-out 0.3s;
    }

    .input-frame {
      display: grid;
      grid-template-columns: repeat(auto-fill, 120px);
      justify-content: center;
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 15px 0 0 0;

      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        max-height: calc((100vh - 160px) / 3);
        overflow: scroll;
        padding: 10px;
      }
    }
    .input-frame-wrap.close {
      height: 0px;
      transition: ease-in-out 0.3s;
    }

    .input-frame-B {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 120px);
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      background: #eee;
      padding: 20px;
      margin: 20px 0 0 0;
      border-radius: 20px;
      border: solid 1px #ccc;

      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        border-radius: unset;
        max-height: calc((100vh - 160px) / 3 * 2);
        overflow: scroll;
        padding: 10px;
      }
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .mobile & {
        overflow: unset;
        text-overflow: unset;
        white-space: unset;
        overflow-wrap: break-word;
      }
    }

    input[type="radio"]:checked + .col1 {
      background: var(--col1);
      color: #fff;
    }

    input[type="radio"]:checked + .col2 {
      // background: var(--col2);
      color: #fff;
    }
    input[type="radio"]:checked + .col3 {
      // background: var(--col3);
      color: #fff;
    }
    input[type="radio"]:checked + .col4 {
      background: var(--col4);
      color: #fff;
    }
    .item-summary {
      display: flex;
      justify-content: space-around;
    }
    .select-button {
      display: block;
      width: 200px;
      margin: 20px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 20px;
      background: var(--purple);
      color: #fff;
      cursor: pointer;
      user-select: none;
      &#selectFlagButton::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic_expand.svg") no-repeat center center;
      }
      &:active {
        opacity: 0.5;
      }
      &#selectItemButton {
        margin: 0;
        width: 170px;
      }

      .mobile & {
        margin: 10px auto 10px;
      }
    }

    .selection-frame {
      display: grid;
      grid-template-columns: 120px 120px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 7px 0 7px 0;
    }

    .message-area {
      display: block;
      margin: 10px 10px 0 10px;

      span {
        font-size: 0.8rem;
      }
    }
  }

  .col1 {
    display: inline-block;
    text-align: center;
    color: var(--col1);
    border: 1px solid var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col1-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2 {
    display: inline-block;
    text-align: center;
    // color: var(--col2);
    // border: 1px solid var(--col2);
    border: 1px solid;
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;

    .mobile & {
      width: 100%;
    }
  }

  .col2-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col2);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col3 {
    display: inline-block;
    text-align: center;
    // color: var(--col3);
    // border: 1px solid var(--col3);
    border: 1px solid;
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;

    .mobile & {
      width: 100%;
    }
  }
  .col3-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col4 {
    display: inline-block;
    text-align: center;
    color: var(--col4);
    border: 1px solid var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col4-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .side-frame-container {
    position: absolute;
    top: 30px;
    right: 30px;
    width: $side-frame-width;
    min-width: 270px;
    //   max-width: 450px;
    min-height: 100px;
    //   padding: 30px 30px 30px 0;
    .mobile & {
      min-width: unset;
      min-height: unset;
    }

    .side-frame {
      // width: 100%;
      // min-width: 270px;
      // max-width: 450px;
      // min-height: 100px;
      padding: 0px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    #side-frame-header {
      // display: flex;
      display: grid;
      grid-template-columns: 1fr 5fr 1fr;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 10px;
      background: #ddd;
      border-radius: 20px 20px 0 0;
      box-sizing: border-box;
    }

    #side-frame-footer {
      width: 100%;
      padding: 5px;
      border-radius: 0 0 20px 20px;
      background: #ddd;
    }

    .side-frame h4 {
      font-size: 18px;
      text-align: center;
      font-weight: normal;
      margin: 0px auto 0;
      // padding: 0 0 0 2em;
    }
    .side-frame h4::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_list.svg") no-repeat center center;
      margin: 0 10px 0 0;
    }

    .side-frame-content {
      // 170px＝サイドフレームの上下padding＋ヘッダ＋フッタ
      max-height: calc(100vh - 170px);
      box-sizing: border-box;
      overflow: scroll;

      .side-frame-content-header {
        overflow: auto;
        width: 100%;
        position: relative;
        font-size: 15px;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 180px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;

          .mobile & {
            grid-template-columns: 1fr 1.5fr;
          }
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }
        }

        .header-title {
          text-align: center;
          font-weight: bold;
        }
        .header-title2 {
          text-align: center;
        }

        table {
          margin: auto;

          .item-title {
            text-align: right;
            padding-right: 10px;
            min-width: 100px;
          }

          .item-name {
            max-width: 150px;
          }
          .item-count {
            text-align: right;
            min-width: 40px;
          }
        }
      }
    }

    .side-frame-row {
      width: 100%;
      margin: 0 auto 0;
      /* min-height: 100px; */
      // border-bottom: solid 1px #ddd;
      border-top: solid 1px #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
    }

    .side-frame-row div {
      display: flex;
      align-items: center;
    }
    .side-frame-row p {
      font-size: 15px;
      display: block;
    }
    .side-frame-row span {
      min-width: 25px;
      width: 25px;
      height: 45px;
      display: block;
      margin: 0 10px 0 0;
    }

    .side-frame-row.view-header {
      cursor: pointer;
    }

    p.view-date {
      font-size: 18px;
    }

    .side-frame-content ul {
      font-size: 14px;
      color: #555;
      background: #f9f9f9;
      margin: 0;
      padding: 20px 20px 20px 40px;
    }

    .side-frame-row .mark {
      font-size: 12px;
      padding: 3px 9px;
    }

    .btn-submit {
      display: block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 100px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
    }

    .btn-close {
      cursor: pointer;
      width: 26px;
      height: 26px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .ricelog_pinicon_010 {
    background: url("~@/assets/pin/ricelog_pinicon_010.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_011 {
    background: url("~@/assets/pin/ricelog_pinicon_011.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_020 {
    background: url("~@/assets/pin/ricelog_pinicon_020.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_021 {
    background: url("~@/assets/pin/ricelog_pinicon_021.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_030 {
    background: url("~@/assets/pin/ricelog_pinicon_030.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_031 {
    background: url("~@/assets/pin/ricelog_pinicon_031.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_040 {
    background: url("~@/assets/pin/ricelog_pinicon_040.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_041 {
    background: url("~@/assets/pin/ricelog_pinicon_041.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_050 {
    background: url("~@/assets/pin/ricelog_pinicon_050.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_051 {
    background: url("~@/assets/pin/ricelog_pinicon_051.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_060 {
    background: url("~@/assets/pin/ricelog_pinicon_060.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_061 {
    background: url("~@/assets/pin/ricelog_pinicon_061.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_070 {
    background: url("~@/assets/pin/ricelog_pinicon_070.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_071 {
    background: url("~@/assets/pin/ricelog_pinicon_071.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_080 {
    background: url("~@/assets/pin/ricelog_pinicon_080.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_081 {
    background: url("~@/assets/pin/ricelog_pinicon_081.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_090 {
    background: url("~@/assets/pin/ricelog_pinicon_090.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_091 {
    background: url("~@/assets/pin/ricelog_pinicon_091.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_100 {
    background: url("~@/assets/pin/ricelog_pinicon_100.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .ricelog_pinicon_101 {
    background: url("~@/assets/pin/ricelog_pinicon_101.png") no-repeat center
      center;
    background-size: 24px 42px;
  }

  .flag01 {
    background: url("~@/assets/flag/flag01.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag02 {
    background: url("~@/assets/flag/flag02.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag03 {
    background: url("~@/assets/flag/flag03.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag04 {
    background: url("~@/assets/flag/flag04.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag05 {
    background: url("~@/assets/flag/flag05.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag06 {
    background: url("~@/assets/flag/flag06.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag07 {
    background: url("~@/assets/flag/flag07.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .flag08 {
    background: url("~@/assets/flag/flag08.png") no-repeat center center;
    background-size: 25px 45px;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .mobile & {
      top: 0;
    }

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;

      .mobile & {
        width: 100%;
        height: 100vh;
        border-radius: 0px;
        padding: 15px;
        max-height: unset;
        top: 0;
      }
    }

    //   &.active {
    //     display: flex;
    //     /* animation: scaleAnimIn 0.3s ease-out; */
    //   }

    .title-area {
      width: 100%;
      height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    #edit-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #edit-area span {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }

    #edit-area span.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }

    #edit-area span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }
    #upload-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #upload-area label {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;

      > input[type="file"] {
        display: none;
      }
    }

    #upload-area label.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }

    #upload-area label::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_upload.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    .upload-area-view {
      width: 100%;

      span {
        position: absolute;
      }
      span.active {
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      span::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_clear.svg") no-repeat center center;
        background-size: 30px 30px;
        padding: 0 0 0 15px;
      }

      img {
        max-width: 100%;
        margin: 10px 0px;
      }
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 180px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;

          .mobile & {
            grid-template-columns: 1fr 1.5fr;
          }
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }
          .input-with-user {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin: 0 0 10px 0;

            .label {
              padding: 0 0 0 5px;
              cursor: pointer;
            }
            .label::before {
              white-space: pre;
              content: "    ";
              background: url("~@/assets/icons/ic_add_circle.svg") no-repeat
                center center;
              background-size: 20px 20px;
              padding: 0 0 0 15px;
            }
          }
        }
        // 行パターンを削除(バリデーションメッセージが表示される際に高さが変わり目立ってしまうため)
        // .columns dt:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }
        // .columns dd:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }

        /* フォーム */

        input[type="text"],
        input[type="date"],
        input[type="number"] {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 16px;
          font-size: 16px;
          outline: none;
        }

        input[type="text"]:focus,
        input[type="date"]:focus,
        input[type="number"]:focus {
          background: var(--purple-tertiary);
        }

        select {
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 38px 0 16px;
          font-size: 16px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center;
          background-size: 25px 25px;
        }

        select:focus {
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center var(--purple-tertiary);
          background-size: 25px 25px;
        }

        textarea {
          font-size: 16px;
          width: 100%;
          min-height: 200px;
          white-space: pre-wrap;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: solid 1px var(--purple);
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          font-family: inherit;
        }

        textarea:focus {
          background: var(--purple-tertiary);
        }

        input[type="radio"] {
          display: none;
        }
        input[type="radio"] + label {
          padding: 0 20px 0 0;
        }
        input[type="radio"]:disabled + label {
          color: #aaa;
        }

        input[type="radio"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
            left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="radio"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
        input[type="radio"]:disabled + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
            center left;
          background-size: 24px 24px;
          display: inline-block;
        }

        input[type="checkbox"] {
          display: none;
        }
        input[type="checkbox"] + label {
          padding: 0 20px 0 0;
        }

        input[type="checkbox"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat
            center left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="checkbox"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
      }
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .scale-enter,
  .scale-leave-to {
    transform: scale(0.5);
    opacity: 0;
  }
  .scale-enter-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-out;
  }
  .scale-leave-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-in;
  }

  /* アニメーション */

  @keyframes scaleAnimIn {
    0% {
      display: flex;
      transform: scale(0.5);
    }
    100% {
      display: flex;
      transform: scale(1);
    }
  }

  @keyframes fadeAnimIn {
    0% {
      display: grid;
      opacity: 0;
    }
    100% {
      display: grid;
      opacity: 1;
    }
  }
}
</style>
